module.exports = __webpack_public_path__ + "static/media/c15.4043c3e7.png";